module.exports = __webpack_public_path__ + "media/images/360/REM_sleep_night_stars-5bb15db9bcf7731b335377edcc26ccaf.jpg";